import { Component } from '@angular/core';
import { HttpService } from '../service/http.service';
import { SchoolInvoiceToValidate } from '../school-invoice-to-validate';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';

@Component({
  selector: 'app-school-invoices-to-validate',
  templateUrl: './school-invoices-to-validate.component.html',
  styleUrls: ['./school-invoices-to-validate.component.css']
})
export class SchoolInvoicesToValidateComponent {
  years: number[] = [];
  invoicesToValidate: SchoolInvoiceToValidate[] = [];
  baseUrl = environment.sbmsBaseUrl;

  constructor(
    private httpService: HttpService
  ){
    let thisYear = moment().year();
    this.httpService.getSchoolInvoicesToValidate(thisYear).subscribe((invoices: SchoolInvoiceToValidate[]) => {
      this.invoicesToValidate = invoices;
  });
    for(let i = 0; i < 6; i++){
      this.years.push(thisYear);
      thisYear--;
    }
  }

  updateList(year: number){
    this.httpService.getSchoolInvoicesToValidate(year).subscribe((invoices: SchoolInvoiceToValidate[]) => {
      this.invoicesToValidate = invoices;
    });
  }

}
